module.exports = __webpack_public_path__ + "dnt-send.png?983ebdfaa18c667280f4b941609f960b";